<div class="wrapper">
  <app-dialog-title 
    class="header"
    title="{{ 'pages.services-state.dialogs.categories.title' | translate }}"
    (close)="close()"
  ></app-dialog-title>
  <section *ngIf="loading" class="loading">
    <mat-progress-spinner
      diameter="20"
      mode="indeterminate"
    ></mat-progress-spinner>
  </section>
  <section *ngIf="!loading" class="categories-list">
    <app-bciti-category-input
      *ngFor="let category of categories$ | async"
      [category]="category"
      [icons]="icons"
      [characterLimit]="14"
      [disabled]="disableActions"
      [textInputHint]="null"
      (onSave)="handleSave($event)"
      (onDelete)="handleDelete($event)"
      (onFormOpen)="closeAllOtherForms($event)"
      (currentState)="toggleAddButtonDisplay($event)"    
    ></app-bciti-category-input>
  </section>
  <section class="add-category" [class.creating]="creating">
    <button 
      *ngIf="toggleAddButton" 
      class="bciti-button bciti-button--blue"
      [disabled]="disableActions"
      (click)="startCreating()"
    >{{ 'common.add' | translate }}</button>
    <app-bciti-category-input
      *ngIf="creating"
      [icons]="icons"
      [characterLimit]="14"
      [textInputHint]="null"
      [disabled]="disableActions"
      (onSave)="handleSave($event)"
      (cancelCreate)="handleCancelCreate()"
    ></app-bciti-category-input>
  </section>
</div>